import apiClient from './api';

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface LoginResponse {
  user: {
    id: string;
    email: string;
    first_name?: string;
    last_name?: string;
  };
  access_token?: string;
  token?: string;
}

export interface ResetPasswordRequest {
  email: string;
}

export interface ResetPasswordResponse {
  message: string;
}

export const authService = {
  login: async (credentials: LoginCredentials): Promise<LoginResponse> => {
    const authResponse = await apiClient.post('/auth/user/emailpass', credentials);

    const sessionResponse = await apiClient.post('/auth/session', {}, {
      headers: {
        'Authorization': `Bearer ${authResponse.data.token}`
      }
    });

    if (authResponse.data.token) {
      localStorage.setItem('token', authResponse.data.token);
    }

    if (sessionResponse.data.user) {
      localStorage.setItem('user', JSON.stringify(sessionResponse.data.user));
    }

    return {
      token: authResponse.data.token,
      user: sessionResponse.data.user
    };
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  resetPassword: async (data: ResetPasswordRequest): Promise<ResetPasswordResponse> => {
    const response = await apiClient.post('/admin/auth/reset-password', {
      email: data.email,
    });
    return response.data;
  },

  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  getToken: () => {
    return localStorage.getItem('token');
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  },
};
